module.exports = __webpack_public_path__ + "static/media/logo.b25bd4f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 399
// module chunks = 0